$(document).ready(function () {
	$(".slick-list").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
    fade:true,
		arrows: false,
		infinite: true,
		autoplay: true,
    speed: 800,
    autoplaySpeed: 4000
	});
	$(".prev-btn").click(function () {
		$(".slick-list").slick("slickPrev");
	});

	$(".next-btn").click(function () {
		$(".slick-list").slick("slickNext");
	});
	$(".prev-btn").addClass("slick-disabled");
	$(".slick-list").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".prev-btn").addClass("slick-disabled");
		} else {
			$(".prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".next-btn").addClass("slick-disabled");
		} else {
			$(".next-btn").removeClass("slick-disabled");
		}
	});
});


/* ++++++++++++++++++++++++++++++ Accordion Js +++++++++++++++++++++++++++++++++++++++++++++++ */


$('.acc-toggle').click(function(e) {
  $(this).toggleClass('active');
  $('.acc-toggle').not(this).removeClass('active');
  	e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        //$(".acc-toggle h6").removeClass("active");
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
        //$(".acc-toggle h6").addClass("active");
    }
});


$('.footer-block__heading').click(function(e) {
  $(this).toggleClass('accordtion-title');
  $(this).parent('.footer-block--menu').toggleClass('accordion-content');
});




/* +++++++++++++++++++++++++++++++++++++++++++++++++++ Review  +++++++++++++++++++++++++++++++++++++++++++++ */

$(document).ready(function () {
	$(".member-list").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows:false,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
            breakpoint: 768,
             settings: {
                    slidesToShow: 1,
                    arrows:true
                }
        }  
       ]
	});
});

$(document).ready(function () {
	$(".c-reviws-slider").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
            breakpoint: 991,
             settings: {
                    slidesToShow: 3,
                }
        },
        {
            breakpoint: 750,
             settings: {
                    slidesToShow: 2,
                }
        },
        {
            breakpoint: 501,
             settings: {
                    slidesToShow: 1,
                    
                }
        }  
       ]
	});
});

/* +++++++++++++++++++++++++++++++++++++++++++++++++++ Review  +++++++++++++++++++++++++++++++++++++++++++++ */

$(document).ready(function () {
	$(".ba-reviws-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
            breakpoint: 991,
             settings: {
                    slidesToShow: 2,
                }
        },
        {
            breakpoint: 750,
             settings: {
                    slidesToShow: 2,
                }
        },
        {
            breakpoint: 501,
             settings: {
                    slidesToShow: 1,
                    
                }
        }  
       ]
	});
});



// 
$(document).ready(function () {
	$(".pw-card-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
            breakpoint: 750,
             settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows:true,
                }
        }
       ]
	});
});

// 

$(document).ready(function () {
	$(".trending--post-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
          breakpoint: 9999,
          settings: 'unslick',
        },  
        {
            breakpoint: 991,
             settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows:true,
                }
        }
       ]
	});
});

$(document).ready(function () {
	$(".insta-feed-list").slick({
		slidesToShow: 6,
		slidesToScroll: 1,
		arrows: true, 
        prevArrow: $('.prev'),
        nextArrow: $('.next') , 
        centerMode: true,
		infinite: true,
		autoplay: false,
        responsive: [
        {
            breakpoint: 1250,
             settings: {
                    slidesToShow: 4,
                }
        },
        {
            breakpoint: 550,
             settings: {
                    slidesToShow: 2,
                }
        }  
       ]
	});
});



$(document).ready(function () {
	$(".collection--product-slider").slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>',
        responsive: [
        {
            breakpoint: 992,
             settings: {
                    slidesToShow: 2,
                    arrows: true,
                }
        },
        {
            breakpoint: 525,
             settings: {
                    slidesToShow: 1,
                    arrows: true,
                }
        }  
       ]
	});
});

$(document).ready(function () {
	$(".product__image-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
        dots:true,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>'
	});
});

$(document).ready(function () {
	$(".testimonial-slider").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
        dots:false,
		infinite: true,
		autoplay: false,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>'
	});
});




$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 80) {
        $("body").addClass("fixed");
    } else {
        $("body").removeClass("fixed");
    }
});

function mobileOnlySlider() {
  $('.trending--post-slider').slick({
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      }  
    },   
    {
      breakpoint: 525,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
});
}
if(window.innerWidth < 768) {
  mobileOnlySlider();
}

$(window).resize(function(e){
    if(window.innerWidth < 991) {
        if(!$('.trending--post-slider').hasClass('slick-initialized')){
            mobileOnlySlider();
        }
    }else{
        if($('.trending--post-slider').hasClass('slick-initialized')){
            $('.trending--post-slider').slick('unslick');
        }
    }
});

/* ====================================================== Add to cart ================================================ */

ajaxAddToCart();
function ajaxAddToCart(){ 
  var ajaxBtn = document.querySelectorAll('.ajax_add_to_cart');
  if(ajaxBtn.length > 0){
    ajaxBtn.forEach((btn) =>{
      btn.addEventListener('click', function(e){
        e.preventDefault();
      	var variantId = this.getAttribute('data-variant_id');
        let formData = {
         'items': [{
          'id': variantId,
          'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          return response.json();
        })
        .then((data) => { 
          var lineItemData=data.items[0];
          var items=fetch('/cart.js').then(response=>response.json()).then(data=>{
           var cart_count_html=`<div class="cart-count-bubble">
                  <span aria-hidden="true">`+ data.item_count +`</span>
                  <span class="visually-hidden">`+data.items.length+` item</span>
              </div>`;
            if(document.querySelector('div.cart-count-bubble')==null)
            {
              var bubble_html=document.querySelector('#cart-icon-bubble').innerHTML;
              bubble_html+=cart_count_html;
              document.querySelector('#cart-icon-bubble').innerHTML=bubble_html;
            }
            else
            {
              document.querySelector(".cart-count-bubble [aria-hidden]").innerHTML=data.item_count;
            }
            document.querySelector('#cart-notification').style.display="block";
            document.querySelector('#cart-notification').classList.add("active");
            var html=`<img src="`+lineItemData.image+`" class="cart-notification-product__image" style="width:70px; height:50px;"/>
              <div>
                <h3 class="cart-notification-product__name h4">`+ lineItemData.title +`</h3>
              </div>`;
            console.log(html)
            document.querySelector('.cart-notification-product').innerHTML=html;
            document.querySelector('.cart-notification__links #cart-notification-button').innerHTML='View my cart ( ' + data.item_count + ' )';
            document.querySelector('.cart-notification__close').onclick=function(){
              document.querySelector('.cart-notification').removeClass('active');
            };
            setTimeout(function(){ document.querySelector('.cart-notification').classList.remove('active'); },8000);   
          })     
        })
      })
    })
  }
}